import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Http } from '../../../../support';
import LoadingButton from '../../../../facturotopia/LoadingButton';

class CancelacionesTicketsActions extends Component {

  state = {
    busy: false,
    showConfirm: false
  }

  handleOnCancelActionClick = () => {
    this.setState({
      showConfirm: true
    });
  }

  handleOnDownloadActionClick = async () => {
    this.setState({
      busy: true
    });

    try {
      const params = {
        download: 1,
        from: this.props.from,
        to: this.props.to,
        as: 'link'
      }

      const response = await Http.get(`${window.BONJOUR_URL}/api/cancelaciones`, { params });

      if (!!response.data) {
        window.location = response.data.link;
      }
    } catch (error) {
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  handleOnAction = (action) => {
  }

  render() {
    const { busy } = this.state;

    return (
      <>
        { Guardian.allows('cancelacion.masiva.descargar.excel.procesado') && (
          <LoadingButton
            variant="secondary"
            loading={ busy }
            className="mr-2"
            onClick={ this.handleOnDownloadActionClick }
          >
            { busy === true ? 'Descargando' : 'Descargar' }
          </LoadingButton>
        )}

        <Button variant="link"
          as={ Link }
          className="text-secondary"
          to="/modulos/cancelaciones/archivos"
        >
          Archivos { ' ' }
          <FontAwesomeIcon icon={ ['fas', 'chevron-right'] } />
        </Button>
      </>

    )
  }
}

export default CancelacionesTicketsActions;